import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.regexp.to-string.js";

var registerStoreModule = function registerStoreModule(store, moduleName, moduleObject) {
  var preserve = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!Object.keys(store.getters).toString().includes(moduleName)) {
    store.registerModule(moduleName.replace('/', ''), moduleObject, {
      preserveState: preserve
    });
  }
};

export default registerStoreModule;